import React from 'react';
import {COMMAND_PRIORITY_LOW} from 'lexical';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {useEffect, useRef} from 'react';
import {IconSave} from '../ToolbarPlugin/icons/index';
import {texts} from '../../texts';
import {SAVE_EDITOR_COMMAND} from './commands';

type Props = {
    onSave: () => void;
};

export const SavePlugin = ({onSave}: Props) => {
    const [editor] = useLexicalComposerContext();
    const onSaveCallback = useRef(onSave);

    useEffect(() => {
        editor.registerCommand(
            SAVE_EDITOR_COMMAND,
            () => {
                if (onSaveCallback) {
                    onSaveCallback.current();
                }
                return true;
            },
            COMMAND_PRIORITY_LOW
        );
    }, [editor]);

    return (
        <button
            title={texts.save_btn_title}
            onClick={() => editor.dispatchCommand(SAVE_EDITOR_COMMAND, undefined)}
            className="priority-editor__toolbar-item"
            aria-label="Save"
        >
            <IconSave className="format" />
        </button>
    );
};
